import CommunityTopicAggregation from "../components/community-topic-aggregation";

export default <template>
  <CommunityTopicAggregation @model={{@model}} />
</template>;
